
/**
 * Array of cancel reasons.
 * @type {Array<{ value: string, label: string }>}
 */
const events = [
  {
    value: 'creditnote.finalized',
    label: 'creditnote.finalized'
  },
	{
    value: 'customer.created',
    label: 'customer.created'
  },
	{
    value: 'customer.updated',
    label: 'customer.updated'
  },
	{
    value: 'invoice.finalized',
    label: 'invoice.finalized'
  },
	{
    value: 'invoice.paid',
    label: 'invoice.paid'
  },
	{
    value: 'invoice.pending',
    label: 'invoice.pending'
  },
	{
    value: 'payment.created',
    label: 'payment.created'
  },
	{
    value: 'payment.deleted',
    label: 'payment.deleted'
  },
	{
    value: 'payment.failed',
    label: 'payment.failed'
  },
	{
    value: 'payment.succeeded',
    label: 'payment.succeeded'
  },
	{
    value: 'payment.updated',
    label: 'payment.updated'
  },
	{
    value: 'source.created',
    label: 'source.created'
  },
	{
    value: 'source.stored',
    label: 'source.stored'
  },
	{
    value: 'source.update',
    label: 'source.update'
  },
	{
    value: 'subscription.cancelled',
    label: 'subscription.cancelled'
  },
	{
    value: 'subscription.created',
    label: 'subscription.created'
  },
	{
    value: 'subscription.needs_attention',
    label: 'subscription.needs_attention'
  },
	{
    value: 'subscription.updated',
    label: 'subscription.updated'
  }
]

export {
  events
}